/**
 * @flow
 * @relayHash 9778d70fc8c062e7b73f0b3cbdee42e9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BarcodeScannerInputQueryVariables = {|
  code: string
|};
export type BarcodeScannerInputQueryResponse = {|
  +barcodeLookup: $ReadOnlyArray<{|
    +type: string,
    +id: string,
    +label: string,
    +code: string,
    +description: ?string,
    +quantity: ?number,
    +lotTracking: ?boolean,
  |}>
|};
export type BarcodeScannerInputQuery = {|
  variables: BarcodeScannerInputQueryVariables,
  response: BarcodeScannerInputQueryResponse,
|};
*/


/*
query BarcodeScannerInputQuery(
  $code: String!
) {
  barcodeLookup(code: $code) {
    type
    id
    label
    code
    description
    quantity
    lotTracking
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "code",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "barcodeLookup",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "BarcodeLookupResult",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lotTracking",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BarcodeScannerInputQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BarcodeScannerInputQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "BarcodeScannerInputQuery",
    "id": null,
    "text": "query BarcodeScannerInputQuery(\n  $code: String!\n) {\n  barcodeLookup(code: $code) {\n    type\n    id\n    label\n    code\n    description\n    quantity\n    lotTracking\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '77368680da6a6030fadd71c9c9167bfb';
module.exports = node;
